type OAuthRequest = {
  resource?: string;
  scope?: string;
};

export const OAUTH_AUTHORIZATION_UNAVAILABLE_MESSAGE =
  "Unable to continue this OAuth authorization. Restart the authorization flow.";

export const isMcpOAuthRequest = ({ resource, scope }: OAuthRequest) => {
  if (scope?.split(/\s+/).some((requestedScope) => requestedScope.startsWith("mcp:"))) return true;
  if (!resource) return false;

  try {
    return new URL(resource).pathname.replace(/\/+$/, "") === "/mcp";
  } catch {
    return false;
  }
};

export const buildOAuthCallbackUrl = ({
  redirect_uri,
  code,
  state,
}: {
  redirect_uri: string;
  code: string;
  state?: string;
}) => {
  const url = new URL(redirect_uri);
  url.searchParams.set("code", code);
  if (state) url.searchParams.set("state", state);
  return url.toString();
};
